import { useCanAdministerAIAgents } from "~/pages/manifold-nextgen/hooks/useCanAdministerAIAgents";
import { Agent, AgentAccessLevel, AgentScope } from "~/services/agents";

// Editing an agent is governed by the caller's `can_edit` grant: editors and
// owners hold it, a USER-level grant does not. A SYSTEM agent's configuration is
// immutable via HTTP, so it is read-only for everyone regardless of level — even
// a directly-granted owner or an `admin:agents` caller. Otherwise an admin can
// edit any CUSTOMER agent via the FGA bypass. Mirrors the backend
// role→permission matrix plus the SYSTEM config-immutability guard.
export const useCanEditAgent = (agent: Agent | undefined): boolean => {
  const isAdmin = useCanAdministerAIAgents();
  return (
    !!agent &&
    agent.scope === AgentScope.CUSTOMER &&
    (agent.access_level === AgentAccessLevel.OWNER ||
      agent.access_level === AgentAccessLevel.EDITOR ||
      isAdmin)
  );
};
